const T = require('prop-types');

module.exports = {
    children: T.func,
    formConfig: T.shape({
        managedFieldNames: T.arrayOf(T.string)
    }),
    formMethods: T.shape({
        getValues: T.func,
        handleSubmit: T.func
    }),
    inputRefs: T.object,
    mode: T.oneOf(['signup', 'edit']),
    onInvalidSubmit: T.func.isRequired,
    onSubmit: T.func.isRequired,
    onSubmitNoRedirect: T.func.isRequired,
    preferencesHandle: T.shape({
        current: T.object,
        getUserPreferences: T.func
    }),
    renderFields: T.func,
    rolePermissions: T.shape({
        canEditAge: T.bool,
        canEditBio: T.bool,
        canEditHomeTown: T.bool,
        canEditIncomingClass: T.bool,
        canEditLiveOnCampus: T.bool,
        canEditMajor: T.bool,
        canEditStudentBio: T.bool,
        defaultPhoto: T.string,
        includePronouns: T.bool,
        profilePicRequired: T.bool
    }),
    saveProfilePicture: T.func,
    shouldScrollToInterests: T.bool,
    stillExistsRef: T.shape({
        current: T.bool
    }),
    useProfanityFilter: T.bool
};
